import { ReactComponent as HomeIcon } from '../../images/home.svg';
import { ReactComponent as PlayerIcon } from '../../images/radio.svg';
import { ReactComponent as DonateIcon } from '../../images/donate_ic.svg';
import { ReactComponent as InfoIcon } from '../../images/info.svg';
import { ReactComponent as FavoriteIcon } from '../../images/favorite.svg';

const MobileNav = ({ activeScreen, onNavigate }) => {
    const navItems = [
        {
            id: 'home',
            label: 'Главная',
            icon: <HomeIcon />
        },
        {
            id: 'player',
            label: 'Плеер',
            icon: <PlayerIcon />
        },
        {
            id: 'donate',
            label: 'Донат',
            icon: <DonateIcon />
        },
        {
            id: 'info',
            label: 'Инфо',
            icon: <InfoIcon />
        },
        {
            id: 'favorites',
            label: 'Избранное',
            icon: <FavoriteIcon />
        }
    ];

    return (
        <nav className="mobile-nav">
            <div className="mobile-nav-bg"></div>
            <div className="mobile-nav-items">
                {navItems.map(({ id, label, icon }) => (
                    <button
                        key={id}
                        className={`mobile-nav-item ${activeScreen === id ? 'active' : ''}`}
                        onClick={() => onNavigate(id)}
                    >
                        {icon}
                        <span className="mobile-nav-label">{label}</span>
                    </button>
                ))}
            </div>
        </nav>
    );
};

export default MobileNav;
